import { render, staticRenderFns } from "./upsell.vue?vue&type=template&id=18e3922f&scoped=true&"
import script from "./upsell.vue?vue&type=script&lang=js&"
export * from "./upsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e3922f",
  null
  
)

export default component.exports